<template>
  <SimpleModuleDashboard
    :module-id="Modules.REDES_SOCIALES"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="actions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    actions: [
      { id: 'configuration', reference: 'configuration', route: 'SocialNetworksStaffConfiguration', tone: 'primary' },
      { id: 'crudInformation', reference: 'crudInformation', route: 'SocialNetworksStaffCrudInformation', tone: 'secondary' },
      {
        id: 'reports',
        dynamic: true,
        title: 'Reportes',
        description: 'Métricas en tiempo real de las acciones en redes sociales',
        icon: 'fa fa-line-chart',
        route: 'SocialNetworksStaffReports',
        tone: 'success',
      },
    ],
  }),
}
</script>
